module.exports = __webpack_public_path__ + "static/img/chat-pass-off.3cd3e06f.png";